<!--It is created by Shyam 10-02-20250-->
<!--Stage Object Component-->
<div class="topDiv" id="topContentDiv" [style.background-color]="backgroundColorScreen"
  style="padding: 5px;">

  <div class="agGridOuterDiv">
    <div>
      <div>
 
        <div class="row topRowMargins headerStyle" style="
          margin-right: 0;
          margin-left: 0; 
          margin-top: 30px;
          ">
          <label i18n="@@spmsUserReg" class="textColour">Stage Objects</label>
          <span class="example-spacer"></span>
            <nav mat-tab-nav-bar mat-stretch-tabs>
            <a
              mat-tab-link
              *ngFor="let link of navLinks"
              [routerLink]="getRouterLink(link)"
              [queryParams]="getQueryParams(link.label)"
              [active]="link.label === 'Stage Objects'"
              style="min-width:130px; opacity: 1;"
              rel="noopener"
            >
              {{ link.label }}
            </a>
          </nav>
        </div>

      </div>

      <div style="margin-top: 25px;">
        <fieldset [disabled]="!isEditMode">
        <form novalidate [formGroup]='validations_form'>
          <div class="row" style="margin-bottom: 1rem;">
            <div class="col-lg-3">
                <mat-form-field appearance="outline" style="width: 100%; box-sizing: border-box; margin-top: 0">
                    <mat-label i18n="@@Targetstdcode"> Source </mat-label>
                    <input
                    matInput
                    [ngModelOptions]="{standalone:true}"
                    [(ngModel)]="name"
                    required
                    placeholder="Enter Source"
                    title="Source"
                    readonly
                  />
                    <!-- <mat-select  [ngModelOptions]="{standalone:true}" [(ngModel)]="name" (ngModelChange)="selectDns($event)">
                        <mat-option style="font-size: 15px;" *ngFor="let eachdns of dnsnames" [value]="eachdns.envname" [disabled]="isEnabled">
                            {{eachdns.envname}}
                        </mat-option>
                    </mat-select> -->
                </mat-form-field>
              </div>

            <div class="col-3" style="text-align: center;">
              <mat-form-field appearance="outline">
                <mat-label i18n="@@TMSTAFFMASTERfirstname">Stage Object Label</mat-label>
                <input matInput type="text" placeholder="Stage Object Label"
                  formControlName="selectdataSet"
                  [(ngModel)]="reportCreationData.datasetname" maxlength="100"
                  required
                  >
                <mat-error *ngFor="let validation of
                  validation_messages.selectstageobject">
                  <span
                    *ngIf="validations_form.get('selectdataSet').hasError(validation.type)
                    && (validations_form.get('selectdataSet').dirty ||
                    validations_form.get('selectdataSet').touched)">
                    {{ validation.message }}
                  </span>
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-3" style="text-align: center;">
              <mat-form-field appearance="outline">
                 <mat-label i18n="@@TMSTAFFMASTERfirstname">Stage Object Name</mat-label>
                <input matInput type="text" placeholder="Satge Object Name"
                  formControlName="description"
                  [(ngModel)]="reportCreationData.description" maxlength="100"
                  required  [readonly]="butttonname === 'Update Stage Object'">
                <mat-error *ngFor="let validation of
                  validation_messages.selectobjectname">
                  <span
                    *ngIf="validations_form.get('description').hasError(validation.type)
                    && (validations_form.get('description').dirty ||
                    validations_form.get('description').touched)">
                    {{ validation.message }}
                  </span>
                </mat-error>
              </mat-form-field>
            </div>
             <div class="col-3" style="text-align: center;">
              <mat-form-field class="filter" appearance="outline">
                <mat-label i18n="@@targetloginusername">
                  Object Group
                </mat-label>
                <mat-select formControlName="objectGroupName" [(ngModel)]="reportCreationData.objectGroupId" (selectionChange)="onObjectGroupChange($event)">
                      <span  *ngFor="let data of objectGroupData">
                <mat-option  *ngIf="data.status == 'Yes'"
                  [value]="data.objectGroupId"
                >
                {{data.objectGroupName}}
                </mat-option>
                </span>
                </mat-select>
                <mat-error *ngFor="let validation of validation_messages.objectGroupName">
                  <span
                    *ngIf="validations_form.get('objectGroupName').hasError(validation.type) && (validations_form.get('objectGroupName').dirty || validations_form.get('objectGroupName').touched)">
                    {{ validation.message }}
                  </span>
                </mat-error>
            </mat-form-field>
            </div>
            <div class="col-3" style="text-align: center;margin-top: 1%;">
              <mat-form-field class="filter" appearance="outline">
                <mat-label i18n="@@targetloginusername">
                  Flattening option
                </mat-label>
                <mat-select formControlName="flattenOptions" [(ngModel)]="reportCreationData.flatteningOption">
                        <mat-option value="">
                           None
                        </mat-option>
                        <mat-option value="Flatten Data">
                           Flatten Data
                        </mat-option>
                        <mat-option value="Flatten without duplicates">
                           Flatten without duplicates
                        </mat-option>
                </mat-select>
                <mat-error *ngFor="let validation of validation_messages.flattenOptions">
                  <span
                    *ngIf="validations_form.get('flattenOptions').hasError(validation.type) && (validations_form.get('flattenOptions').dirty || validations_form.get('flattenOptions').touched)">
                    {{ validation.message }}
                  </span>
                </mat-error>
            </mat-form-field>
            </div>
            <div class="col-3" style="text-align: center;margin-top: 1%;">
              <mat-form-field appearance="outline">
                 <mat-label i18n="@@TMSTAFFMASTERfirstname">Order Id</mat-label>
                <input matInput type="number" placeholder="Order Id"
                  formControlName="orderId"
                  [(ngModel)]="reportCreationData.orderId" maxlength="100"
                  required>
                <mat-error *ngFor="let validation of
                  validation_messages.orderId">
                  <span
                    *ngIf="validations_form.get('orderId').hasError(validation.type)
                    && (validations_form.get('orderId').dirty ||
                    validations_form.get('orderId').touched)">
                    {{ validation.message }}
                  </span>
                </mat-error>
              </mat-form-field>
            </div>
              <div class="col-3" style="margin-top: 1%;">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@TMclassifiedserviceType">Reference Source Objects</mat-label>
                  <input matInput type="text"  [(ngModel)]="selectedReferenceSourceObjectsListNames" (click)="searchableReferenceSourceObjects()"
                    formControlName="selectedReferenceSourceObjectsListNamesForm" readonly>
                    <mat-error *ngFor="let validation of validation_messages.selectedReferenceSourceObjectsListNamesForm">
                      <span
                        *ngIf="validations_form.get('selectedReferenceSourceObjectsListNamesForm').hasError(validation.type) && (validations_form.get('selectedReferenceSourceObjectsListNamesForm').dirty || validations_form.get('selectedReferenceSourceObjectsListNamesForm').touched)">
                        {{ validation.message }}
                      </span>
                    </mat-error>
                </mat-form-field>
              </div>
               <div class="col-lg-3" style="margin-top: 1%;">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@TMclassifiedserviceType">Reference Stage Objects</mat-label>
                  <input matInput type="text"  [(ngModel)]="selectedReferenceTargetObjectsListNames" (click)="searchableReferenceTargetObjects()"
                    formControlName="selectedReferenceTargetObjectsListNamesForm" readonly>
                    <mat-error *ngFor="let validation of validation_messages.selectedReferenceTargetObjectsListNamesForm">
                      <span
                        *ngIf="validations_form.get('selectedReferenceTargetObjectsListNamesForm').hasError(validation.type) && (validations_form.get('selectedReferenceTargetObjectsListNamesForm').dirty || validations_form.get('selectedReferenceTargetObjectsListNamesForm').touched)">
                        {{ validation.message }}
                      </span>
                    </mat-error>
                </mat-form-field>
              </div>
               <div class="col-lg-3" style="margin-top: 1%;"> 
        <mat-form-field appearance="outline" >
          <mat-label i18n="@@TMSTAFFMASTERfirstname">Reference Value Mapping</mat-label>
          <mat-select
                multiple
                matNativeControl
                [(ngModel)]="selectedReferenceValueMapping"
                formControlName="selectedReferenceValueMappingForm"
              >
                <span  *ngFor="let data of codeListData">
                <mat-option  *ngIf="data.status == 'Yes'"
                  [value]="data.mappingTypeName"
                >
                {{ data.mappingTypeName }}
                </mat-option>
                </span>
               
              </mat-select> 
            <mat-error *ngFor="let validation of validation_messages.selectedReferenceValueMappingForm">
              <span
                  *ngIf="validations_form.get('selectedReferenceValueMappingForm').hasError(validation.type) && (validations_form.get('selectedReferenceValueMappingForm').dirty || validations_form.get('selectedReferenceValueMappingForm').touched)">
                  {{ validation.message }}
              </span>
          </mat-error>
        </mat-form-field>
          </div>
           <div class="col-lg-3" style="margin-top: 1%;">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@TMclassifiedserviceType">Reference Library Objects</mat-label>
                  <input matInput type="text"  [(ngModel)]="selectedReferenceLibraryObjectsListNames" (click)="searchableReferenceLibraryObjects()"
                    formControlName="selectedReferenceLibraryForm" readonly>
                    <mat-error *ngFor="let validation of validation_messages.selectedReferenceLibraryForm">
                      <span
                        *ngIf="validations_form.get('selectedReferenceLibraryForm').hasError(validation.type) && (validations_form.get('selectedReferenceLibraryForm').dirty || validations_form.get('selectedReferenceLibraryForm').touched)">
                        {{ validation.message }}
                      </span>
                    </mat-error>
                </mat-form-field>
              </div>
               <div class="col-lg-3" style="margin-top: 1%;">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@TMclassifiedserviceType">Reference Global Target Objects</mat-label>
                  <input matInput type="text"  [(ngModel)]="selectedReferenceGlobalObjectsListNames" (click)="searchableReferenceGlobalObjects()"
                    formControlName="selectedReferenceGlobalObjectsListNamesForm" readonly>
                    <mat-error *ngFor="let validation of validation_messages.selectedReferenceGlobalObjectsListNamesForm">
                      <span
                        *ngIf="validations_form.get('selectedReferenceGlobalObjectsListNamesForm').hasError(validation.type) && (validations_form.get('selectedReferenceGlobalObjectsListNamesForm').dirty || validations_form.get('selectedReferenceGlobalObjectsListNamesForm').touched)">
                        {{ validation.message }}
                      </span>
                    </mat-error>
                </mat-form-field>
              </div>
               <div class="col-lg-3" style="margin-top: 1%;">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@TMclassifiedserviceType">Reference Global Source Objects</mat-label>
                  <input matInput type="text"  [(ngModel)]="selectedReferenceGlobalSourceObjectsListNames" (click)="searchableReferenceGlobalSourceObjects()"
                    formControlName="selectedReferenceGlobalSourceObjectsListNamesForm" readonly>
                    <mat-error *ngFor="let validation of validation_messages.selectedReferenceGlobalSourceObjectsListNamesForm">
                      <span
                        *ngIf="validations_form.get('selectedReferenceGlobalSourceObjectsListNamesForm').hasError(validation.type) && (validations_form.get('selectedReferenceGlobalSourceObjectsListNamesForm').dirty || validations_form.get('selectedReferenceGlobalSourceObjectsListNamesForm').touched)">
                        {{ validation.message }}
                      </span>
                    </mat-error>
                </mat-form-field>
              </div>
           <div class="col-lg-3" style="margin-top: 1%;">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@TMclassifiedserviceType">Global External Objects</mat-label>
                  <input matInput type="text"  [(ngModel)]="selectedGlobalExternalObjectsListNames" (click)="searchableGlobalExternalObjects()"
                    formControlName="selectedGlobalExternalObjectsListNamesForm" readonly>
                    <mat-error *ngFor="let validation of validation_messages.selectedGlobalExternalObjectsListNamesForm">
                      <span
                        *ngIf="validations_form.get('selectedGlobalExternalObjectsListNamesForm').hasError(validation.type) && (validations_form.get('selectedGlobalExternalObjectsListNamesForm').dirty || validations_form.get('selectedGlobalExternalObjectsListNamesForm').touched)">
                        {{ validation.message }}
                      </span>
                    </mat-error>
                </mat-form-field>
              </div> 
              <div class="col-lg-3" style="margin-top: 1%;">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@TMclassifiedserviceType">Reference DB Object Name</mat-label>
                  <input matInput type="text"  [(ngModel)]="selectedRefDBObjectNameListNames" (click)="searchableTargetObjectsForRefDBObjectName()"
                    formControlName="selectedRefDBObjectNameListNamesForm" readonly>
                    <mat-error *ngFor="let validation of validation_messages.selectedRefDBObjectNameListNamesForm">
                      <span
                        *ngIf="validations_form.get('selectedRefDBObjectNameListNamesForm').hasError(validation.type) && (validations_form.get('selectedRefDBObjectNameListNamesForm').dirty || validations_form.get('selectedRefDBObjectNameListNamesForm').touched)">
                        {{ validation.message }}
                      </span>
                    </mat-error>
                </mat-form-field>
              </div>  
              <div class="col-lg-3" style="margin-top: 1%;">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@TMclassifiedserviceType">Reference DB Object Fetch Partials</mat-label>
                  <input matInput type="text"  [(ngModel)]="selectedRefDBObjectNameFetchPartialsListNames" (click)="searchableTargetObjectsForRefDBObjectNameFetchPartials()"
                    formControlName="selectedRefDBObjectNameFetchPartialsListNamesForm" readonly>
                    <mat-error *ngFor="let validation of validation_messages.selectedRefDBObjectNameFetchPartialsListNamesForm">
                      <span
                        *ngIf="validations_form.get('selectedRefDBObjectNameFetchPartialsListNamesForm').hasError(validation.type) && (validations_form.get('selectedRefDBObjectNameFetchPartialsListNamesForm').dirty || validations_form.get('selectedRefDBObjectNameFetchPartialsListNamesForm').touched)">
                        {{ validation.message }}
                      </span>
                    </mat-error>
                </mat-form-field>
              </div> 
             <!-- referenceTargetObjectsList -->
          </div>
        </form>
        </fieldset>
      </div>
      <div class="row">
        <div style="width: 32%;">
          <div class="seperateDiv">
            <ag-grid-angular class="ag-theme-balham table-width-fields
              tablestyles square scroolbar-dusty-grass square thin"
              [columnDefs]="columnDefsForObjects" [animateRows]="true"
              [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true"
              [rowSelection]="rowSelection" [rowHeight]="35" [headerHeight]="35"
              [enableBrowserTooltips]="true" [floatingFiltersHeight]="45"
              [enableRangeSelection]="true" [debug]="true"
              (gridReady)="onGridReadyForObjects($event,value)"
              (cellClicked)="cellClickedObjects($event)" [hidden]="!true">
            </ag-grid-angular>
          </div>
        </div>

        <div style="width: 1%;">

        </div>

        <div style="width: 32%;">
          <div class="seperateDiv">
            <ag-grid-angular class="ag-theme-balham table-width-fields
              tablestyles square scroolbar-dusty-grass square thin"
              [columnDefs]="columnDefsForTablesFields" [animateRows]="true"
              [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true"
              [rowSelection]="rowSelectionForTablesFields" [rowHeight]="35"
              [headerHeight]="35" [enableBrowserTooltips]="true"
              [floatingFiltersHeight]="45" [enableRangeSelection]="true"
              [debug]="true" [components]="components"
              (gridReady)="onGridReadyForTablesFields($event,ngModelObjectTemporary,
              'test')"
              (rowSelected)="onRowSelected($event)" [hidden]="!true">
            </ag-grid-angular>
          </div>
        </div>

        <div style="width: 2%;margin: auto;font-size: 1.8rem;text-align:
          center;">
          <div>
            <div (click)="isEditMode && pushDataToSelectedFieldsGrid('insert')">
              <em class="fas fa-step-forward" title="Move selected rows to
                Right"></em>
            </div>
            <div (click)="isEditMode &&  pushDataToSelectedFieldsGridComplete()">
              <em class="fas fa-forward" title="Move all rows to Right"></em>
            </div>
            <div (click)="isEditMode &&  popDataToSelectedFieldsGridComplete()">
              <em class="fas fa-backward" title="Move all rows to Left"></em>
            </div>
            <div (click)="isEditMode && popDataToSelectedFieldsGrid()">
              <em class="fas fa-step-backward" title="Move selected rows to
                Left"></em>
            </div>
            <div (click)="isEditMode &&  groupConcat()">
              <em class="fas fa-link" title="Concatenate Selected fields"></em>
            </div>
            <div (click)="isEditMode &&  unGroupConcat()">
              <em class="fas fa-unlink" title="UnConcatenate Selected fields"></em>
            </div>
          </div>
        </div>

        <div style="width: 32%;">
          <div class="seperateDiv">
            <ag-grid-angular class="ag-theme-balham table-width-fields
              tablestyles square scroolbar-dusty-grass square thin"
              [columnDefs]="columnDefsForSelectedFields"
              [defaultColDef]="defaultColDef" [animateRows]="true"
              [rowDragManaged]="true"
              (rowDragEnter)="onRowDragEnter($event)"
              (rowDragEnd)="onRowDragEnd($event)"
              (rowDragMove)="onRowDragMove($event)"
              (rowDragLeave)="onRowDragLeave($event)"
              [sortingOrder]="sortingOrder"
              [rowSelection]="rowSelectionForTablesFields" [rowHeight]="35"
              [headerHeight]="35"
              (gridReady)="onGridReadyForSelectedTableFields($event,ngModelObjectTemporary)"
              (rowSelected)="onRowSelectedToRemove($event)"
              (cellEditingStarted) = "onCellEditingStarted($event)"
              (cellValueChanged)="onCellValueChanged($event)" [hidden]="!true">
            </ag-grid-angular>
          </div>
        </div>

      </div>

      <div style="
        margin-bottom: 2em;"></div>

      <mat-expansion-panel [expanded]="false" style="border-radius: 0.8vh 0.8vh 0
        0; box-shadow: none;">
        <mat-expansion-panel-header style="max-height: 50px; background: rgb(228
          227 230 / 41%);border: 1px solid #a9a9a9a8;">
          <mat-panel-title>
            <label style="font-size: 22px; font-weight: 500; margin-top: 10px;"
              i18n="@@spmsUserReg" class="textColour">Stage Object Creation Options</label>
            <span class="example-spacer"></span>
          </mat-panel-title>
          <mat-panel-description>

          </mat-panel-description>
        </mat-expansion-panel-header>

        <div style="margin-top: 3%;">
          <div class="container" style="border-bottom: 0.01px ridge
          coral;margin-bottom: 2em;">
            <div class="row">
              <div class="col-lg" style="margin-top: -30px;">
                <div class="row topRowMargins">
                  <label style="font-weight: 500;
                    font-size: larger;
                    color: black;">Expression Query <em class="fas fa-gears"
                      style="font-size:20px"></em></label>
                </div>
              </div>
            </div>
         <div class="row" style="margin-bottom: 3%;">
            <div class="col-lg-12" style="padding: 0;">
                 <!-- <form [formGroup]="validations_form"> -->
  <!-- <mat-form-field  > -->
  <!-- <textarea matInput rows="2"     
            formControlName="expressionQuery" #codeEditor 
            required
             [readonly]="isEditMode"></textarea> -->
       <!-- <app-code-editor
  [(value)]="expressionDetails"
  [objectsDetails]="selectedObjectsAndAttributes"
  height="200px"
  (valueChange)="onExpressionChange($event)">
</app-code-editor> -->
<app-code-editor
  [(value)]="expressionDetails"
  [objectsDetails]="temp"
  height="200px"
  (valueChange)="onExpressionChange($event)"
  (editorBlur)="validations_form.get('expressionQuery')?.markAsTouched()">
</app-code-editor>

<mat-error
  *ngIf="validations_form.get('expressionQuery')?.hasError('required') &&
         validations_form.get('expressionQuery')?.touched">
  Expression Query is required
</mat-error>
  <!-- <mat-error *ngIf="validations_form.get('expressionQuery').errors &&
                  (validations_form.get('expressionQuery').dirty || validations_form.get('expressionQuery').touched)">
  <ng-container *ngIf="validations_form.get('expressionQuery').hasError('required')">
    Expression Query is required.
  </ng-container>
  <ng-container *ngIf="validations_form.get('expressionQuery').hasError('whitespace')">
    Expression Query should not contain any white spaces.
  </ng-container>
</mat-error> -->
<!-- </mat-form-field>
</form> -->

            </div>
          </div>
          </div>
          <div *ngIf="false" class="container" style="border-bottom: 0.01px ridge
            coral;margin-bottom: 2em;">
            <div class="row" style="margin-bottom:1rem">
              <div class="col-lg" style="margin-bottom:1rem;margin-top: -30px;">
                <div class="row topRowMargins">
                  <label style="font-weight: 500;
                    font-size: larger;
                    color: black;">Transformation <em class="fas fa-gears"
                      style="font-size:20px"></em></label>
                </div>
              </div>
            </div>

            <div class="container">
              <div class="row" *ngIf="showTransform" style="margin-top:
                -30px;margin-bottom: 30px;">
                <div class="table-responsive">
                  <table class="table" style="margin-top: -57px;"><caption></caption>
                    <thead>
                      <tr>
                        <th class="th-lg">Object</th>
                        <th class="th-lg">Key</th>
                        <th class="th-lg">Reference Objects</th>
                        <th class="th-lg">SQL</th>
                        <th class="th-lg">Remove</th>
                      </tr>
                    </thead>
                    <tbody style="border:none;">
                      <tr *ngFor="let transformationObject of transformation; let k= index;">
                        <td class="conditionsalign">{{transformationObject.object}}</td>
                        <td class="conditionsalign">{{transformationObject.attribute}}</td>
                        <td class="conditionsalign" style="padding-left:
                          115px;">{{transformationObject.referenceObjects}}</td>
                        <td class="conditionsalign" style="padding-left:
                          120px;">{{transformationObject.sql}}</td>
                        <td class="conditionsalign" style="text-align: end;
                          padding-right: 33px;"><label class="CloseButtonStyle"><span>
                              <em (click)="deleteTransformation(k)" class="fas fa-minus"
                                style="color: white;" title="Remove"></em></span></label></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <form novalidate [formGroup]="transformationFormGroup">
              <div>
                <div class="row topRowMargins" style="margin-top: -25px;">
                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCFields">Objects</mat-label>
                      <mat-select [(ngModel)]="transformationObjectData.object"
                        (selectionChange)="onTransformationObjectSelection($event)"
                        formControlName="transformationObject">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let field of filterObjects"
                          [(value)]="field.object">
                          {{field.name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCFields">Attributes</mat-label>
                      <mat-select [(ngModel)]="transformationObjectData.attribute"
                        formControlName="transformationAttribute">
                        <mat-option *ngFor="let field of filterData"
                          [(value)]="field.name">
                          {{field.alias}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCConditionalOperators">Reference Objects</mat-label>
                      <mat-select [(ngModel)]="transformationReferenceList"
                        formControlName="transformationReference"
                        (selectionChange)="onTransformationReferenceObjectSelection($event)" multiple>
                        <mat-option *ngFor="let referenceObject of referenceObjects"
                          [(value)]="referenceObject.objectname">
                          {{referenceObject.object}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-2">
                    <mat-form-field class="valueField" appearance="outline">
                      <mat-label i18n="@@RCEnterValue">Enter SQL</mat-label>
                      <textarea matInput placeholder="Enter SQL" formControlName="transformationSql"
                      [(ngModel)]="transformationObjectData.sql" cdkTextareaAutosize cdkAutosizeMinRows="1"></textarea>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-1">
                    <div>
                      <label (click)="addTransformation()" style="margin-top: 6px;
                        background: green;
                        margin-bottom: auto;
                        padding: 2px 5px 0px 5px;
                        border-radius: 15px;"><em class="fas fa-plus"
                          style="color:
                          antiquewhite;font-size: large;" title="Add"></em></label>
                    </div>
                  </div>
                </div>
              </div>
            </form>

          </div>
        </div>

        <div *ngIf="false">
          <div class="container" style="border-bottom: 0.01px ridge
            coral;margin-bottom: 2em;">
            <div class="row" style="margin-bottom:1rem">
              <div class="col-lg" style="margin-bottom:1rem;margin-top: -30px;">
                <div class="row topRowMargins">

                  <label style="font-weight: 500;
                    font-size: larger;
                    color: black;">Rolling Up <em class="fas fa-link"
                      style="font-size:20px"></em></label>
                </div>
              </div>
            </div>

            <div class="container">
              <div class="row" *ngIf="showRollingUp" style="margin-top:
                -30px;margin-bottom: 30px;">
                <div class="table-responsive" *ngIf="showRollingUp">
                  <table class="table" style="font-weight: bold;"><caption></caption>
                    <thead>
                      <tr>
                        <th class="th-lg">Parent Object </th>
                        <th class="th-lg">Parent Object Attributes</th>
                        <th class="th-lg">Child Object</th>
                        <th class="th-lg">Child Object Attributes</th>
                        <th class="th-lg">RollupAlias</th>
                        <th class="th-lg">Remove</th>
                      </tr>
                    </thead>
                    <tbody style="border:none;">
                      <tr *ngFor="let eachrollingup of rollingUp; let k=
                        index;">
                        <td class="conditionsalign">{{eachrollingup.parentObjectName}}</td>
                        <td class="conditionsalign">{{eachrollingup.parentAttributesalias}}</td>
                        <td class="conditionsalign">{{eachrollingup.childObjectName}}</td>
                        <td class="conditionsalign">{{eachrollingup.childAttributesalias}}</td>
                        <td class="conditionsalign" >{{eachrollingup.rollupColumnAlias}}</td>
                        <td class="conditionsalign"><label
                            class="CloseButtonStyle"><span>
                              <em (click)="deleteRollingUp(k)" class="fas
                                fa-minus"
                                style="color: white;" title="Remove"></em></span></label></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="row topRowMargins" style="margin-top: -25px;">
              <div class="col-lg-2">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@RCFields">Rollup Exclusion Object</mat-label>
                  <mat-select [(ngModel)]="rollupExclusionObjects" multiple
                    (selectionChange)="rollupExclusionObjectSelection()">
                    <mat-option *ngFor="let field of filterObjects"
                      [(value)]="field.object">
                      {{field.name}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <form novalidate [formGroup]="formValidAttributes">
              <div>
                <div class="row topRowMargins" style="margin-top: -25px;">
                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCFields">Parent Object</mat-label>
                      <mat-select [(ngModel)]="rollingupdata.parentObjectName"
                        formControlName="datasetNameone"
                        (selectionChange)="changeRollingUpDatasetNameOne($event)">
                        <mat-option *ngFor="let field of filterObjects"
                          [(value)]="field.object">
                          {{field.name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCFields">Attributes</mat-label>
                      <mat-select [(ngModel)]="parentattribute"
                        formControlName="attributes"
                        (selectionChange)="changeRollingUpParentAttributes($event)">
                        <mat-option *ngFor="let field of datasetOneAttributes;
                          let
                          em= index" [(value)]="datasetOneAttributes[em]">
                          {{field.attributeNameWithFields}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCFields">Child Object</mat-label>
                      <mat-select [(ngModel)]="rollingupdata.childObjectName"
                        formControlName="datasetNametwo"
                        (selectionChange)="changeRollingUpDatasetNameTwo($event)">
                        <mat-option *ngFor="let field of filterObjects"
                        [(value)]="field.object">
                        {{field.name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCFields">Attributes</mat-label>
                      <mat-select
                        [(ngModel)]="rollingupdatatemp.childattributes"
                        formControlName="attributestwo"
                        (selectionChange)="changeRollingUpChildAttributes($event)">
                        <mat-option *ngFor="let eachdatasettwoattributes of
                          datasetTwoAttributes; let em=index"
                          [(value)]="datasetTwoAttributes[em]">
                          {{eachdatasettwoattributes.attributeNameWithFields}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@TMSTAFFMASTERfirstname">RollingUp Alias</mat-label>
                        <input matInput type="text" placeholder="{{rollingupdata.rollupColumnAlias}}" [(ngModel)]="rollingupdata.rollupColumnAlias"
                          formControlName="constant" (input) = "onRollupAliasChange($event.target.value)">
                    </mat-form-field>
                  </div>

                  <div class="col-lg-1" style="display: inline-flex;
                    justify-content: space-between;">
                    <label (click)="addRollingup()" style="margin-top: 6px;
                      background: green;
                      margin-bottom: auto;
                      padding: 2px 5px 0px 5px;
                      border-radius: 15px;"><em class="fas fa-plus" style="color:
                        antiquewhite;font-size: large;" title="Add"></em></label>
                    <div style="margin-left: 1rem;margin-top: .4rem;">
                      <mat-checkbox class="mat-checkbox-layout" ngDefaultControl
                        [(ngModel)]="applyRecordFilter" [checked] = "applyRecordFilter" (change)="applyRecordFilterSelection()">Apply
                        Record Filter?</mat-checkbox>
                    </div>
                  </div>
                </div>
                <div *ngIf="applyRecordFilter" class="row topRowMargins"
                  style="margin-top: -25px;">
                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCFields">Child Object</mat-label>
                      <input matInput readonly type="text" [value]="rollingupdata.childObjectName"
                        formControlName="selectedChildDataSet"
                        [(ngModel)]="rollingupdata.childObjectName">
                    </mat-form-field>
                  </div>
                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCFields">Filter Criteria</mat-label>
                      <mat-select [(ngModel)]="recordfilterData.fieldsWhere"
                        formControlName="fieldsWhere"
                        (selectionChange)="recordLevelAttrbuteSelection($event)">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let field of recordLevelFilterData"
                          [(value)]="field.alias">
                          {{field.alias}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCConditionalOperators">Condition</mat-label>
                      <mat-select
                        [(ngModel)]="recordfilterData.conditionalOperatorWhere"
                        formControlName="recordConditionalOperatorWhere"
                        (selectionChange)="recordFilterCondition($event)">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let conditionalOperator of
                          conditionalOperatorDataWhere"
                          [(value)]="conditionalOperator.value">
                          {{conditionalOperator.name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-2">
                    <div *ngIf="recordBetweenField">
                      <div *ngIf="recordMultiField" style="display: inline-flex;
                        justify-content: space-between; max-width: 100%;">
                        <mat-form-field class="valueField" appearance="outline">
                          <mat-label i18n="@@RCEnterValue">Enter Start Value</mat-label>
                          <input matInput type="text" maxlength="50"
                            formControlName="enterValueWhere"
                            [(ngModel)]="recordfilterData.enterValueBetweenStart">
                        </mat-form-field>
                        <mat-form-field class="valueField" appearance="outline"
                          style="margin-left: 1rem;">
                          <mat-label i18n="@@RCEnterValue">Enter End Value</mat-label>
                          <input matInput type="text" maxlength="50"
                            formControlName="enterValueWhere"
                            [(ngModel)]="recordfilterData.enterValueBetweenEnd">
                        </mat-form-field>
                      </div>
                      <div *ngIf="recordMultiDate" style="display: inline-flex;
                        justify-content: space-between; max-width: 100%;">
                        <mat-form-field appearance="outline">
                          <mat-label i18n="@@TMSTAFFMASTERLastname">Select Start
                            Date</mat-label>
                          <input matInput
                            [(ngModel)]="recordfilterData.enterValueBetweenStart"
                            [matDatepicker]="recordDate1"
                            readonly formControlName="enterValueWhere">
                          <mat-datepicker-toggle matSuffix [for]="recordDate1">
                            <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                          </mat-datepicker-toggle>
                          <mat-datepicker #recordDate1></mat-datepicker>
                        </mat-form-field>
                        <mat-form-field appearance="outline" style="margin-left:
                          1rem;">
                          <mat-label i18n="@@TMSTAFFMASTERLastname">Select End
                            Date</mat-label>
                          <input matInput
                            [(ngModel)]="recordfilterData.enterValueBetweenEnd"
                            [matDatepicker]="recordDate2"
                            readonly formControlName="enterValueWhere">
                          <mat-datepicker-toggle matSuffix [for]="recordDate2">
                            <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                          </mat-datepicker-toggle>
                          <mat-datepicker #recordDate2></mat-datepicker>
                        </mat-form-field>
                      </div>
                    </div>
                    <div *ngIf="recordDateField">
                      <mat-form-field appearance="outline">
                        <mat-label i18n="@@TMSTAFFMASTERLastname">Select Date</mat-label>
                        <input matInput
                          [(ngModel)]="recordfilterData.enterValueWhereDate"
                          [matDatepicker]="recordDate"
                          readonly formControlName="enterValueWhere">
                        <mat-datepicker-toggle matSuffix [for]="recordDate">
                          <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                        </mat-datepicker-toggle>
                        <mat-datepicker #recordDate></mat-datepicker>
                      </mat-form-field>
                    </div>
                    <div *ngIf="recordValueField">
                      <mat-form-field appearance="outline">
                        <mat-label i18n="@@RCEnterValue">Enter Value</mat-label>
                        <input matInput type="text" maxlength="50"
                          formControlName="enterValueWhere"
                          [(ngModel)]="recordfilterData.enterValueWhere">
                      </mat-form-field>
                    </div>
                    <div *ngIf="recordMultiselect">
                      <mat-form-field appearance="outline">
                        <mat-label i18n="@@RCFields">Select Values</mat-label>
                        <mat-select [(ngModel)]="recordfilterData.multiSelect" multiple
                          formControlName="recordMultiselect">
                          <mat-option>None</mat-option>
                          <mat-option *ngFor="let field of multiSelectVaules"
                            [(value)]="field.alias">
                            {{field.alias}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-lg-1">
                    <div *ngIf="recordscheduleRange" style="margin-left: -13.5vw;">
                      <label (click)="addRecordFilter()" style="margin-top: 6px;
                        background: green;
                        margin-bottom: auto;
                        padding: 2px 5px 0px 5px;
                        border-radius: 15px;"><em class="fas fa-plus"
                          style="color:
                          antiquewhite;font-size: large;" title="Add Filters"></em></label></div>
                    <div *ngIf="recordBetweenField" style="margin-left: 12.5vw;">
                      <label (click)="addRecordFilter()" style="margin-top: 6px;
                        background: green;
                        margin-bottom: auto;
                        padding: 2px 5px 0px 5px;
                        border-radius: 15px;"><em class="fas fa-plus"
                          style="color:
                          antiquewhite;font-size: large;" title="Add Filters"></em></label></div>
                    <div *ngIf="!recordBetweenField && !recordscheduleRange">
                      <label (click)="addRecordFilter()" style="margin-top: 6px;
                        background: green;
                        margin-bottom: auto;
                        padding: 2px 5px 0px 5px;
                        border-radius: 15px;"><em class="fas fa-plus"
                          style="color:
                          antiquewhite;font-size: large;" title="Add Filters"></em></label>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>

        </div>

        <div *ngIf="false" style="
          margin-bottom: 0;"></div>

        <div style="margin-left:2%;margin-right:2%">
          <div class="container" style="border-bottom: 0.01px ridge
            coral;margin-bottom: 0;">
            <div class="row" style="margin-bottom:0">
              <div class="col-lg" style="margin-bottom:0;margin-top: -30px;">
                <div class="row topRowMargins">
                  <label style="font-weight: 500;
                    font-size: larger;
                    color: black;">Column Filters <em class="fas fa-filter"
                      style="font-size:20px"></em></label>
                </div>
              </div>
            </div>
            <pre *ngIf="getSQL().length > 0 "  style="border: 1px solid #ccc;
              padding: 1%;
              background: lightgray;">{{ getSQL() }}</pre>
          <div *ngIf="rootGroup" style=" max-height: 400px;
              overflow-y: auto;
              overflow-x: hidden;margin-bottom: 2%;">
           
            <ng-container
              [ngTemplateOutlet]="groupTemplate"
              [ngTemplateOutletContext]="{ group: rootGroup }"
            ></ng-container>
           
          </div>
          <ng-template #groupTemplate let-group="group" >
            <div style="    
              width: 100%;
              padding: 0;">
            <div style="border: 1px solid #ccc;padding: 10px; margin-bottom: 15px;position: relative;">
            
              <mat-form-field class="filter" appearance="outline" style="width: 15%;margin-right: 2%;">
                <mat-label i18n="@@targetloginusername">
                    Condition
                </mat-label>
                <mat-select  [(ngModel)]="group.condition">
                        <mat-option value="AND">AND</mat-option>
                        <mat-option value="OR">OR</mat-option>
                </mat-select>
            </mat-form-field>
              <div *ngFor="let rule of group.rules; let i = index">
                <div class="row" *ngIf="rule.type === 'rule'">
                  <div class="col-lg-3">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCFields">Select Object</mat-label>
                      <mat-select [(ngModel)]="rule.object"  (selectionChange)="onObjectSelectionChange($event, rule,'lhs')">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let field of filterObjects"
                          [(value)]="field.object">
                          {{field.name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                   <div class="col-lg-3">
                        <mat-form-field class="filter" appearance="outline">
                            <mat-label i18n="@@targetloginusername">
                                Select Attribute
                            </mat-label>
                            <mat-select  [(ngModel)]="rule.field">
                                    <mat-option *ngFor="let field of rule.availableAttributes" [value]="field">
                                      {{field}}
                                    </mat-option>
                            </mat-select>
                        </mat-form-field>
                      </div>
                       <div class="col-lg-3">
                        <mat-form-field class="filter" appearance="outline">
                            <mat-label i18n="@@targetloginusername">
                                Select Operator
                            </mat-label>
                            <mat-select  [(ngModel)]="rule.operator">
                                    <mat-option *ngFor="let op of operators" [value]="op">
                                      {{ op }}
                                    </mat-option>
                            </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="col-lg-3"  *ngIf="rule.operator.includes('(field)')">
                         <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCFields">Select Object</mat-label>
                        <mat-select [(ngModel)]="rule.rhsObject" (selectionChange)="onObjectSelectionChange($event, rule, 'rhs')">
                          <mat-option *ngFor="let obj of filterObjects" [value]="obj.object">{{ obj.name }}</mat-option>
                        </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="col-lg-3" *ngIf="rule.operator.includes('(field)')" style="display: flex;">
                          <mat-form-field class="filter" appearance="outline">
                            <mat-label i18n="@@targetloginusername">
                                Select Attribute
                            </mat-label>
                            <mat-select [(ngModel)]="rule.rhsField" >
                            <mat-option *ngFor="let attr of rule.rhsAvailableAttributes" [value]="attr">
                              {{ attr }}
                            </mat-option>
                          </mat-select>
                          </mat-form-field>
                      </div>
                       <div class="col-lg-3"  style="display: flex;">
                        <mat-form-field appearance="outline" style="width: 80%;" *ngIf="!rule.operator.includes('(field)') && rule.operator !== 'IS NULL' && rule.operator !== 'IS NOT NULL'">
                            <mat-label i18n="@@TMSTAFFMASTERfirstname">Value</mat-label>
                              <input matInput type="text" placeholder="Value" [(ngModel)]="rule.value">
                          </mat-form-field>
                          <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="buttonColor" title="Remove Rule" (click) = "removeRule(group, i)" style="width: 10%;
                          box-shadow: none !important;
                          background-color: rgb(253, 152, 13);
                          height: 25px;
                          font-size: medium;">✖</button>
                      </div>
                  <!-- <input [(ngModel)]="rule.value" placeholder="Value" />
                  <button (click)="removeRule(group, i)">Remove</button> -->
                </div>

                <div *ngIf="rule.type === 'group'" style="position: relative;margin-bottom: 20px;">
                  <ng-container
                    [ngTemplateOutlet]="groupTemplate"
                    [ngTemplateOutletContext]="{ group: rule }"
                  ></ng-container>
                   <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="buttonColor" title="Add Record" (click) = "removeRule(group, i)" id="114" style="    
                    width: 25px;
                    box-shadow: none !important;
                    background-color: rgb(253, 152, 13);
                    height: 25px;
                    font-size: medium;
                    top: -20px;
                    position: absolute;
                    right: -15px;">✖</button>
                  <!-- <button (click)="removeRule(group, i)">Remove Group</button> -->
                </div>
              </div>
                <label (click)="addRule(group)" style="margin-top: 6px;
                        background: green;
                        margin-bottom: auto;
                        padding: 2px 5px 0px 5px;
                        border-radius: 15px;margin-right: 2%;"><em class="fas fa-plus"
                          style="color:
                          antiquewhite;font-size: large;" title="Add Rule"></em></label>
                <button   class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="buttonColor" title="Add Group" (click) = "addGroup(group)" style="margin-top: 0;height: 25px;box-shadow: none !important;width:80px">Add Group</button>
              <!-- <button (click)="addGroup(group)">+ Add Group</button> -->
            </div>
            </div>
          </ng-template>
          
          </div>
          <!-- OLD code -->
          <div *ngIf="false" class="container" style="border-bottom: 0.01px ridge
            coral;margin-bottom: 2em;">
            <div class="row" style="margin-bottom:1rem">
              <div class="col-lg" style="margin-bottom:1rem;margin-top: -30px;">
                <div class="row topRowMargins">
                  <label style="font-weight: 500;
                    font-size: larger;
                    color: black;">Inclusion Filters <em class="fas fa-filter"
                      style="font-size:20px"></em></label>
                </div>
              </div>
            </div>

            <div class="container">
              <div class="row" *ngIf="showFilter" style="margin-top:
                -30px;margin-bottom: 30px;">
                <div class="table-responsive">
                  <table class="table" style="margin-top: -57px;"><caption></caption>
                    <thead>
                      <tr>
                        <th class="th-lg">Object</th>
                        <th class="th-lg">Key</th>
                        <th class="th-lg">Condition</th>
                        <th class="th-lg">Value</th>
                        <th class="th-lg">Remove</th>
                      </tr>
                    </thead>
                    <tbody style="border:none;">
                      <tr *ngFor="let whereData of where; let k= index;">
                        <td class="conditionsalign">{{whereData.objectWhere}}</td>
                        <td class="conditionsalign">{{whereData.whereKey}}</td>
                        <td class="conditionsalign" style="padding-left:
                          115px;">{{whereData.whereCondition}}</td>
                        <td class="conditionsalign" style="padding-left:
                          120px;">{{whereData.whereValue}}</td>
                        <td class="conditionsalign" style="padding-left:
                          120px;">{{whereData.whereValue1}}</td>
                        <td class="conditionsalign" style="text-align: end;
                          padding-right: 33px;"><label class="CloseButtonStyle"><span>
                              <em (click)="deleteWhere(k)" class="fas fa-minus"
                                style="color: white;" title="Remove"></em></span></label></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <form novalidate [formGroup]="formValidWhere">
              <div>
                <div class="row topRowMargins" style="margin-top: -25px;">
                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCFields">Objects</mat-label>
                      <mat-select [(ngModel)]="whereData.objectWhere"
                        (selectionChange)="whereKey($event)"
                        formControlName="objectWhere">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let field of filterObjects"
                          [(value)]="field.object">
                          {{field.name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCFields">Attributes</mat-label>
                      <mat-select [(ngModel)]="whereData.fieldsWhere"
                        formControlName="fieldsWhere"
                        (selectionChange)="attrbuteSelection($event)">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let field of inclusionAttributes"
                          [(value)]="field.label">
                          {{field.label}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCConditionalOperators">Condition</mat-label>
                      <mat-select
                        [(ngModel)]="whereData.conditionalOperatorWhere"
                        formControlName="conditionalOperatorWhere"
                        (selectionChange)="filterCondition($event)">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let conditionalOperator of
                          conditionalOperatorDataWhere"
                          [(value)]="conditionalOperator.value">
                          {{conditionalOperator.name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-2">
                    <div *ngIf="betweenField">
                      <div *ngIf="valueField" style="display: inline-flex;
                        justify-content: space-between; max-width: 100%;">
                        <mat-form-field class="valueField" appearance="outline">
                          <mat-label i18n="@@RCEnterValue">Enter Start Value</mat-label>
                          <input matInput type="text" maxlength="50"
                            formControlName="enterValueWhere"
                            [(ngModel)]="whereData.enterValueBetweenStart">
                        </mat-form-field>
                        <mat-form-field class="valueField" appearance="outline"
                          style="margin-left: 1rem;">
                          <mat-label i18n="@@RCEnterValue">Enter End Value</mat-label>
                          <input matInput type="text" maxlength="50"
                            formControlName="enterValueWhere"
                            [(ngModel)]="whereData.enterValueBetweenEnd">
                        </mat-form-field>
                      </div>
                      <div *ngIf="dateChange" style="display: inline-flex;
                        justify-content: space-between; max-width: 100%;">
                        <mat-form-field appearance="outline">
                          <mat-label i18n="@@TMSTAFFMASTERLastname">Select Start
                            Date</mat-label>
                          <input matInput
                            [(ngModel)]="whereData.enterValueBetweenStart"
                            [matDatepicker]="whereDate1"
                            readonly formControlName="enterValueWhere">
                          <mat-datepicker-toggle matSuffix [for]="whereDate1">
                            <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                          </mat-datepicker-toggle>
                          <mat-datepicker #whereDate1></mat-datepicker>
                        </mat-form-field>
                        <mat-form-field appearance="outline" style="margin-left:
                          1rem;">
                          <mat-label i18n="@@TMSTAFFMASTERLastname">Select End
                            Date</mat-label>
                          <input matInput
                            [(ngModel)]="whereData.enterValueBetweenEnd"
                            [matDatepicker]="whereDate2"
                            readonly formControlName="enterValueWhere">
                          <mat-datepicker-toggle matSuffix [for]="whereDate2">
                            <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                          </mat-datepicker-toggle>
                          <mat-datepicker #whereDate2></mat-datepicker>
                        </mat-form-field>
                      </div>
                    </div>
                    <div *ngIf="dateField">
                      <mat-form-field appearance="outline">
                        <mat-label i18n="@@TMSTAFFMASTERLastname">Select Date</mat-label>
                        <input matInput
                          [(ngModel)]="whereData.enterValueWhereDate"
                          [matDatepicker]="whereDate"
                          readonly formControlName="enterValueWhere">
                        <mat-datepicker-toggle matSuffix [for]="whereDate">
                          <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                        </mat-datepicker-toggle>
                        <mat-datepicker #whereDate></mat-datepicker>
                      </mat-form-field>
                    </div>
                    <div *ngIf="fieldChange">
                      <mat-form-field appearance="outline">
                        <mat-label i18n="@@RCEnterValue">Enter Value</mat-label>
                        <input matInput type="text" maxlength="50"
                          formControlName="enterValueWhere"
                          [(ngModel)]="whereData.enterValueWhere">
                      </mat-form-field>
                    </div>
                    <div *ngIf="multiselect">
                      <mat-form-field appearance="outline">
                        <mat-label i18n="@@RCFields">Select Values</mat-label>
                        <mat-select [(ngModel)]="whereData.multiSelect" multiple
                          formControlName="multiselect">
                          <mat-option *ngFor="let field of multiSelectVaules"
                            [(value)]="field.alias">
                            {{field.alias}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-lg-1">
                    <div *ngIf="scheduleRange" style="margin-left: -14vw;">
                      <label (click)="addWhere()" style="margin-top: 6px;
                        background: green;
                        margin-bottom: auto;
                        padding: 2px 5px 0px 5px;
                        border-radius: 15px;"><em class="fas fa-plus"
                          style="color:
                          antiquewhite;font-size: large;" title="Add Filters"></em></label></div>
                    <div *ngIf="betweenField" style="margin-left: 12.5vw;">
                      <label (click)="addWhere()" style="margin-top: 6px;
                        background: green;
                        margin-bottom: auto;
                        padding: 2px 5px 0px 5px;
                        border-radius: 15px;"><em class="fas fa-plus"
                          style="color:
                          antiquewhite;font-size: large;" title="Add"></em></label></div>
                    <div *ngIf="!betweenField && !scheduleRange">
                      <label (click)="addWhere()" style="margin-top: 6px;
                        background: green;
                        margin-bottom: auto;
                        padding: 2px 5px 0px 5px;
                        border-radius: 15px;"><em class="fas fa-plus"
                          style="color:
                          antiquewhite;font-size: large;" title="Add"></em></label>
                    </div>
                  </div>

                </div>
              </div>
            </form>
          </div>

          <div class="container" style="border-bottom: 0.01px ridge
            coral;margin-bottom: 2em;">
            <div class="row" style="margin-bottom:1rem">
              <div class="col-lg" style="margin-bottom:1rem;margin-top: 0px;">
                <div class="row topRowMargins">

                  <label style="font-weight: 500;
                    font-size: larger;
                    color: black;">Sorting<em class="fas fa-sort" style="
                      font-size: 23px;
                      padding: 0px 0px 0px 6px;"></em></label>
                </div>
              </div>
            </div>

            <div class="container">
              <div class="row" *ngIf="showOrderBy" style="margin-top: -30px;
                margin-bottom: 30px;">
                <div class="table-responsive">
                  <table class="table" ><caption></caption>
                    <thead>
                      <tr>
                        <th class="th-lg">Object</th>
                        <th class="th-lg">Key</th>
                        <th class="th-lg">Align</th>
                        <th class="th-lg">Remove</th>
                      </tr>
                    </thead>
                    <tbody style="border:none;">
                      <tr *ngFor="let eachorder of orderBy;let o= index;">
                        <td class="conditionsalign">{{eachorder.orderObject}}</td>
                        <td class="conditionsalign">{{eachorder.orderKey}}</td>
                        <td class="conditionsalign"   >{{eachorder.orderAllign}}</td>
                        <td class="conditionsalign" style="padding-right: 36px;">
                          <label class="CloseButtonStyle"><span> <em
                                (click)="deleteOrder(k)" class="fas fa-minus"
                                style="color: white;" title="Remove "></em></span></label>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <form novalidate [formGroup]="formValidWhere">
              <div>
                <div class="row topRowMargins" style="margin-top: -25px;">

                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCFields">Attributes</mat-label>
                      <mat-select [(ngModel)]="orderByData.fieldsOrderBy"
                        formControlName="fieldsOrderBy">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let field of columns"
                          [(value)]="field.alias">
                          {{field.alias}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCConditionalOperators">Sorting</mat-label>
                      <mat-select [(ngModel)]="orderByData.arrangeOrderBy"
                        formControlName="arrangeOrderBy">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let arrange of arrangeDataOrderBy"
                          [(value)]="arrange.value">
                          {{arrange.name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <div class="col-lg-1">
                    <label (click)="addOrderBy()" style="margin-top: 6px;
                      background: green;
                      margin-bottom: auto;
                      padding: 2px 5px 0px 5px;
                      border-radius: 15px;"><em class="fas fa-plus" style="color:
                        antiquewhite;font-size: large;" title="Add"></em></label>
                  </div>
                </div>
              </div>
            </form>
          </div>
<!-- ===================20-11-2024===================================== -->
<div *ngIf="false" class="container" style="border-bottom: 0.01px ridge
            coral;margin-bottom: 2em;">
  <div class="row" style="margin-bottom:1rem">
    <div class="col-lg" style="margin-bottom:1rem;margin-top: -30px;">
      <div class="row topRowMargins">

        <label style="font-weight: 500;
                    font-size: larger;
                    color: black;">Modify Column Data Type</label>
                    <!-- <em class="fas fa-sort" style="
                                          font-size: 23px;
                                          padding: 0px 0px 0px 6px;"></em> -->
      </div>
    </div>
  </div>

  
  <div class="container">
    <div class="row" *ngIf="showHeaderType" style="margin-bottom: 30px; margin-top: -45px;">
      <div class="table-responsive" *ngIf="showHeaderType">
        <table class="table" style="font-weight: bold;">
          <caption></caption>
          <thead style="font-weight: bolder;">
            <tr>
              <th class="th-lg">Object Name</th>
              <th class="th-lg">Attribute</th>
              <th class="th-lg">Alias</th>
              <th class="th-lg">Data Type</th>
              <th class="th-lg">Remove</th>
            </tr>
          </thead>
          <tbody style="border:none;">
           
            <tr *ngFor="let eachorder of headersTypeArr; let o = index;">
              <td class="conditionsalign">{{ eachorder.headerKeyObject }}</td>
              <td class="conditionsalign">{{ eachorder.headerKey }}</td>
              <td class="conditionsalign">{{ eachorder.headerKeyAlias }}</td>
              <td class="conditionsalign">{{ eachorder.headerKeyType }}</td>
              <td class="conditionsalign">
                <label class="CloseButtonStyle">
                  <span>
                    <em (click)="deleteHeader(o)" class="fas fa-minus" style="color: white;" title="Remove"></em>
                  </span>
                </label>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <form novalidate [formGroup]="formValidHeaderType">
    <div>
      <div class="row topRowMargins" style="margin-top: -25px;">

        
        <div class="col-lg-1.5">
          <mat-form-field appearance="outline">
            <mat-label i18n="@@RCConditionalOperators">Column Name</mat-label>
            <mat-select [(ngModel)]="headerTypeObj.headerKeyAlias"formControlName="headerKeyAlias" (selectionChange)="onHeaderChangeSelection($event)" multiple>
              <mat-option *ngFor="let referenceObject of columns" [value]="referenceObject.alias">
                <!-- (filteredColumns.length === 0 ? columns : filteredColumns) -->
                {{ referenceObject.alias }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

       
          <div class="col-lg-2">
            <mat-form-field appearance="outline">
              <mat-label i18n="@@RCFields">Data Type</mat-label>
              <mat-select [(ngModel)]="headerTypeObj.headerKeyType" formControlName="headerKeyType">
                <mat-option>None</mat-option>
                <mat-option *ngFor="let header of arrangeDataByForHeaderType" [(value)]="header.value">
                  {{header.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

        <div class="col-lg-1">
          <label (click)="addHeaderType   ()" style="margin-top: 6px;
                      background: green;
                      margin-bottom: auto;
                      padding: 2px 5px 0px 5px;
                      border-radius: 15px;"><em class="fas fa-plus" style="color:
                        antiquewhite;font-size: large;" title="Add"></em></label>

        </div>
      </div>
    </div>
  </form>
</div>

<!-- ===================20-11-2024===================================== -->

          <div *ngIf="false" class="container" style="border-bottom: 0.01px ridge
            coral;margin-bottom: 2em;">
            <div class="row" style="margin-bottom:1rem">
              <div class="col-lg" style="margin-bottom:1rem;margin-top: -30px;">
                <div class="row topRowMargins">

                  <label style="font-weight: 500;
                    font-size: larger;
                    color: black;">Aggregate<em class="fas fa-calculator" style="
                      font-size: 23px;
                      padding: 0px 0px 0px 6px;"></em></label>
                </div>
              </div>
            </div>

            <div class="container">
              <div class="row" *ngIf="showAggregate" style=
                "margin-bottom: 30px; margin-top: -45px;" >
                <div class="table-responsive" *ngIf="showAggregate">
                  <table class="table" style="font-weight: bold;"><caption></caption>
                    <thead style="font-weight: bolder;">
                      <tr>
                        <th class="th-lg">Aggregate On</th>
                        <th class="th-lg">Aggregate Function</th>
                        <th class="th-lg">Group By Function</th>
                        <th class="th-lg">Partition On</th>
                        <th class="th-lg">Distinct On</th>
                        <th class="th-lg">Column Alias</th>
                        <th class="th-lg">Aggregation Condition</th>
                        <th class="th-lg">Remove</th>
                      </tr>
                    </thead>
                    <tbody style="border:none;">
                      <tr *ngFor="let data of aggregateBy;let a=
                        index;">
                        <td class="conditionsalign">{{data.aggregateColumn}}</td>
                        <td class="conditionsalign">{{data.aggregateFunction}}</td>
                        <td class="conditionsalign">{{data.groupByFunction}}</td>
                        <td class="conditionsalign">{{data.partitionByColumn}}</td>
                        <td class="conditionsalign">{{data.distinctColumns}}</td>
                        <td class="conditionsalign">{{data.alias}}</td>
                        <td class="conditionsalign">{{data.conditionalValue}}</td>
                        <td class="conditionsalign">
                          <label class="CloseButtonStyle"><span> <em
                                (click)="deleteAggregate(a)" class="fas
                                fa-minus"
                                style="color: white; "  title="Remove"></em></span></label>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <form novalidate [formGroup]="formValidWhere">
              <div>
                <div class="row topRowMargins" style="margin-top: -25px;">


                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCFields">Aggregate On</mat-label>
                      <mat-select
                        [(ngModel)]="aggregateByData.aggregateOn"
                        formControlName="aggregateOn">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let field of columns"
                          [(value)]="field.alias">
                          {{field.alias}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
          

                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCFields">Aggregate Function</mat-label>
                      <mat-select [(ngModel)]="aggregateByData.aggregateFunction" formControlName="aggregateFunction">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let aggregate of arrangeDataBy" [(value)]="aggregate.value">
                          {{aggregate.name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
               
                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCFields">Group by Function</mat-label>
                      <mat-select [(ngModel)]="aggregateByData.groupByFunction" formControlName="aggregateFunction">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let aggregate of arrangeDataBy" [(value)]="aggregate.value">
                          {{aggregate.name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                
                  <div class="col-lg-1.5">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCConditionalOperators">Partition On</mat-label>
                      <mat-select [(ngModel)]="aggregateByData.partionOn"
                        formControlName="partionOn"
                        (selectionChange)="onPartitionChangeSelection($event)" multiple>
                        <mat-option *ngFor="let referenceObject of columns"
                          [(value)]="referenceObject.alias">
                          {{referenceObject.alias}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-1.5" style="margin-left:1.5%">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCConditionalOperators">Distinct On</mat-label>
                      <mat-select [(ngModel)]="aggregateByData.distinctColumns"
                        formControlName="orderBy"
                        (selectionChange)="onOrderByChangeSelection($event)" multiple>
                        <mat-option *ngFor="let referenceObject of columns"
                          [(value)]="referenceObject.alias">
                          {{referenceObject.alias}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCLabel">Column Alias</mat-label>
                      <input matInput type="text" maxlength="50" pattern="[a-zA-Z0-9\s\-_]+" title="special character not allowed"
                        formControlName="columnAlias" 
                        [(ngModel)]="aggregateByData.columnAlias">
                      <mat-error *ngFor="let validation of
                        validation_messages.label">
                       
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-6">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCLabel">Aggregation condition</mat-label>
                      <textarea matInput maxlength="500" rows="1" 
                                formControlName="conditionalValue"
                                [(ngModel)]="aggregateByData.conditionalValue">
                      </textarea>
                      <mat-error *ngFor="let validation of validation_messages.label">
                        <!-- You can add your validation messages here -->
                      </mat-error>
                    </mat-form-field>
                  </div>
                  
   <!-- ====================================================================            -->
                  <div class="col-lg-1">
                    <label (click)="addAggregate()" style="margin-top: 6px;
                      background: green;
                      margin-bottom: auto;
                      padding: 2px 5px 0px 5px;
                      border-radius: 15px;"><em class="fas fa-plus" style="color:
                        antiquewhite;font-size: large;" title="Add"></em></label>
                  </div>
                </div>
              </div>
            </form>
          </div>


          <div *ngIf="false" class="container" style="border-bottom: 0.01px ridge
          coral;margin-bottom: 2em;">
            <div class="row" style="margin-bottom:1rem">
              <div class="col-lg" style="margin-bottom:1rem;margin-top: -30px;">
                <div class="row topRowMargins">

                  <label style="font-weight: 500;
                    font-size: larger;
                    color: black;">Pivot Aggregate</label>
                </div>
              </div>
            </div>
            
            <div class="container">
              <div class="row" *ngIf="showPivotAggregate" style=
                "margin-bottom: 30px; margin-top: -45px;" >
                <div class="table-responsive" *ngIf="showPivotAggregate">
                  <table class="table" style="font-weight: bold;"><caption></caption>
                    <thead style="font-weight: bolder;">
                      <tr>
                        <th class="th-lg">Column Alias</th>
                        <th class="th-lg">Case Column</th>
                        <th class="th-lg">Pivot Column</th>
                        <th class="th-lg">Child Columns</th>
                        <th class="th-lg">Headers To Null</th>
                        <th class="th-lg">Order BY Columns</th>
                        <th class="th-lg">Parent Columns</th>
                        <th class="th-lg">Header Value Column</th>
                        <th class="th-lg">Remove</th>
                      </tr>
                    </thead>
                    <tbody style="border:none;">
                      <tr *ngFor="let data of pivotAggregateBy;let a=
                        index;">
                         <td class="conditionsalign">{{data.alias}}</td>
                        <td class="conditionsalign">{{data.caseColumn}}</td>
                        <td class="conditionsalign">{{data.pivotColumn}}</td>
                        <td class="conditionsalign">{{data.childColumns}}</td>
                        <td class="conditionsalign">{{data.headersToNull}}</td>
                        <td class="conditionsalign">{{data.orderByColumn}}</td>
                        <td class="conditionsalign">{{data.parentcolumns}}</td>
                        <td class="conditionsalign">{{data.headerValueColumn}}</td>
                        <td class="conditionsalign">
                          <label class="CloseButtonStyle"><span> <em
                                (click)="deletePivotAggregate(a)" class="fas
                                fa-minus"
                                style="color: white; "  title="Remove"></em></span></label>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <form novalidate [formGroup]="formValidWhere">
              <div>
                   <div class="row topRowMargins" style="margin-top: -25px;">
                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCLabel">Column Alias</mat-label>
                      <input matInput type="text" maxlength="50" pattern="[a-zA-Z0-9\s\-_]+" title="special character not allowed"
                        formControlName="pivotColumnAlias" 
                        [(ngModel)]="pivotAggregateByData.columnAlias">
                      <mat-error *ngFor="let validation of
                        validation_messages.label">

                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCFields">Case Column</mat-label>
                      <mat-select
                        [(ngModel)]="pivotAggregateByData.caseColumn"
                        formControlName="caseColumn">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let field of columns"
                          [(value)]="field.alias">
                          {{field.alias}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCFields">Pivot Column</mat-label>
                      <mat-select
                        [(ngModel)]="pivotAggregateByData.pivotColumn"
                        formControlName="pivotColumn">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let field of columns"
                          [(value)]="field.alias">
                          {{field.alias}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCConditionalOperators">Child Columns</mat-label>
                      <mat-select [(ngModel)]="pivotAggregateByData.childColumns"
                        formControlName="childColumns"
                        (selectionChange)="onOrderByChildColumns($event)" multiple>
                        <mat-option *ngFor="let referenceObject of columns"
                          [(value)]="referenceObject.alias">
                          {{referenceObject.alias}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  
                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCConditionalOperators">Headers To Null</mat-label>
                      <mat-select [(ngModel)]="pivotAggregateByData.headersToNull"
                        formControlName="headersToNull"
                        (selectionChange)="onOrderByorderedHeadersToNull($event)" multiple>
                        <mat-option *ngFor="let referenceObject of columns"
                          [(value)]="referenceObject.alias">
                          {{referenceObject.alias}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCConditionalOperators">Order BY Columns</mat-label>
                      <mat-select [(ngModel)]="pivotAggregateByData.orderByColumn"
                        formControlName="orderByColumn"
                        (selectionChange)="onOrderByorderedOrderByColumn($event)" multiple>
                        <mat-option *ngFor="let referenceObject of columns"
                          [(value)]="referenceObject.alias">
                          {{referenceObject.alias}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCConditionalOperators">Parent Columns</mat-label>
                      <mat-select [(ngModel)]="pivotAggregateByData.parentcolumns"
                        formControlName="parentcolumns"
                        (selectionChange)="onOrderByorderedParentcolumns($event)" multiple>
                        <mat-option *ngFor="let referenceObject of columns"
                          [(value)]="referenceObject.alias">
                          {{referenceObject.alias}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <div class="col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCFields">Header Value Column</mat-label>
                      <mat-select
                        [(ngModel)]="pivotAggregateByData.headerValueColumn"
                        formControlName="headerValueColumn">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let field of columns"
                          [(value)]="field.alias">
                          {{field.alias}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <div class="col-lg-1">
                    <label (click)="addPivotAggregate()" style="margin-top: 6px;
                      background: green;
                      margin-bottom: auto;
                      padding: 2px 5px 0px 5px;
                      border-radius: 15px;"><em class="fas fa-plus" style="color:
                        antiquewhite;font-size: large;" title="Add"></em></label>
                   </div>                   
                    </div>
                    </div>
                    </form>
          </div>

<div *ngIf="aggregateBy.length >0" class="container" style="border-bottom: 0.01px ridge
            coral;margin-bottom: 2em;">
  <div class="row" style="margin-bottom:1rem">
    <div class="col-lg" style="margin-bottom:1rem;margin-top: -30px;">
      <div class="row topRowMargins">

        <label style="font-weight: 500;
                    font-size: larger;
                    color: black;">Secondary Aggregate<em class="fas fa-calculator" style="
                      font-size: 23px;
                      padding: 0px 0px 0px 6px;"></em></label>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="row" *ngIf="showSubLevelAggregate" style="margin-bottom: 30px; margin-top: -45px;">
      <div class="table-responsive" *ngIf="showSubLevelAggregate">
        <table class="table" style="font-weight: bold;">
          <caption></caption>
          <thead style="font-weight: bolder;">
            <tr>
              
              <th class="th-lg">Group By Column</th>
              <th class="th-lg">Alias</th>
              <th class="th-lg">Remove</th>
              
            </tr>
          </thead>
          <tbody style="border:none;">
            <tr *ngFor="let data of subLevelAggregateBy;let k=
                        index;">
              
              <td class="conditionsalign">{{data.groupByColumn}}</td>
              <td class="conditionsalign">{{data.alias}}</td>
              
             
              <td class="conditionsalign">
                <label class="CloseButtonStyle"><span> <em (click)="deleteSubLevelAggregate(k)" class="fas
                                fa-minus" style="color: white;" title="Remove"></em></span></label>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <form novalidate [formGroup]="formValidWhere">
    <div>
      <div class="row topRowMargins" style="margin-top: -25px;">


       
        
        <!-- =================================================================================== -->
        
        <div class="col-lg-6" style="margin-left:1.5%" >
          <mat-form-field  appearance="outline" >
            <mat-label i18n="@@RCConditionalOperators">Group By Column</mat-label>
            <mat-select [(ngModel)]="subAggregateLevelData.groupByColumn" formControlName="groupBysecondary"
              (selectionChange)="onOrderByChangeSelection($event)" multiple>
              <mat-option  *ngFor="let referenceObject of columns" [(value)]="referenceObject.alias">
                {{referenceObject.alias}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
<div class="col-lg-2">
  <mat-form-field appearance="outline">
    <mat-label i18n="@@RCLabel">Alias</mat-label>
    <input matInput type="text" maxlength="50" pattern="[a-zA-Z0-9\s\-_]+" title="special character not allowed"
      formControlName="goupByColumnAlias" [(ngModel)]="subAggregateLevelData.alias">
    <mat-error *ngFor="let validation of
                        validation_messages.label">
      <!-- <span
                          *ngIf="formulaFields.get('label').hasError(validation.type)
                          && (formulaFields.get('label').dirty ||
                          formulaFields.get('label').touched)">
                          {{ validation.message }}
                        </span> -->
    </mat-error>
  </mat-form-field>
</div>
        
       
        <!-- ====================================================================            -->
        <div class="col-lg-1" >
          <label (click)="addSubAggregateLevel()" style="margin-top: 6px;
                      background: green;
                      margin-bottom: auto;
                      padding: 2px 5px 0px 5px;
                      border-radius: 15px;"><em class="fas fa-plus" style="color:
                        antiquewhite;font-size: large;" title="Add"></em></label>
        </div>
      </div>
    </div>
  </form>
</div>

<!-- ***************************************************************************** -->
          <!-- Formula Field Section -->
          <div [hidden]="true" class="container" style="border-bottom: 0.01px ridge
            coral;margin-bottom: 2.5em;">
            <div class="row" style="margin-bottom:1rem">
              <div class="col-lg" style="margin-top: -30px;">
                <div class="row topRowMargins">

                  <label style="font-weight: 500;
                    font-size: larger;
                    color: black;">Formula Attributes<em class="fas fa-file"
                      style=" font-size: 23px;
                      padding: 0px 0px 0px 6px;"></em></label>
                </div>
              </div>
            </div>
            <form novalidate [formGroup]="formulaFields" style="margin-bottom:
              1em;">
              <div class="row">
                <div class="col-lg-2">
                  <mat-form-field appearance="outline">
                    <mat-label i18n="@@RCLabel">Label</mat-label>
                    <input matInput type="text" maxlength="50"
                      formControlName="label"
                      [(ngModel)]="formulaFieldsByData.labelformulafieldsBy">
                    <mat-error *ngFor="let validation of
                      validation_messages.label">
                      <span
                        *ngIf="formulaFields.get('label').hasError(validation.type)
                        && (formulaFields.get('label').dirty ||
                        formulaFields.get('label').touched)">
                        {{ validation.message }}
                      </span>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-lg-2">
                  <mat-form-field appearance="outline">
                    <mat-label i18n="@@RCReturntype">Return Type</mat-label>
                    <mat-select
                      [(ngModel)]="formulaFieldsByData.returntypeformulafieldsBy"
                      formControlName="returntype">
                      <mat-option value="textbox">Text</mat-option>
                      <mat-option value="textbox">Number</mat-option>
                      <mat-option value="Date">Date</mat-option>
                      <mat-option value="Yes/No">Yes/No</mat-option>
                      <mat-option value="DateTime">DateTime</mat-option>
                      <mat-option value="Icon">Icon</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="col-lg-2">
                  <mat-form-field appearance="outline">
                    <mat-label i18n="@@RCObject">Fields</mat-label>
                    <mat-select
                      [(ngModel)]="formulaFieldsByData.objectformulafieldsBy"
                      formControlName="object">
                      <mat-option>None</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-lg-2">
                  <mat-form-field appearance="outline">
                    <mat-label i18n="@@RCFunctions">Functions</mat-label>
                    <mat-select
                      [(ngModel)]="formulaFieldsByData.functionsformulafieldsBy"
                      formControlName="functions">
                      <mat-option>None</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-lg-2">
                  <mat-form-field appearance="outline">
                    <mat-label i18n="@@RCOprations">Operations</mat-label>
                    <mat-select
                      [(ngModel)]="formulaFieldsByData.oprationsformulafieldsBy"
                      formControlName="oprations">
                      <mat-option>None</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-lg-1">
                  <label style="margin-top: 6px;
                    background: green;
                    margin-bottom: auto;
                    padding: 2px 5px 0px 5px;
                    border-radius: 15px;">
                    <em class="fas fa-plus" style="color: antiquewhite;font-size:
                      large;" title="Add Formula"></em>
                  </label>

                </div>

              </div>
            </form>


          </div>
          <!-- Formula Field Section End -->
        </div>

      </mat-expansion-panel>

      
       <div class="col-lg">
        <div class="container" style="text-align: center;">
          <div class="row topRowMargins">
            <!-- <div *ngIf="!isViewAction"  class="col-lg-2" style="margin-left: 10rem;"> -->
              <!-- <mat-checkbox class="mat-checkbox-layout" ngDefaultControl
              [(ngModel)]="generateDefaultTemplate" style="margin-top: 1.5vh;">Initiate
              Template Creation</mat-checkbox>
              <mat-checkbox class="mat-checkbox-layout" ngDefaultControl
              [(ngModel)]="autoRefreshDataset">Auto-Refresh Dataset</mat-checkbox> -->
            <!-- </div> -->
            <div *ngIf="!isViewAction" style="margin-left: 5rem; display: flex;justify-content: space-evenly; width: 40%; height:fit-content;margin:auto; margin-top: 1rem;" >
              <button  i18n="@@TMRunButton" type="button"
                (click)="createreport()"
                [disabled]="!isEditMode"
                [style.background-color]="buttonColor"
                class="actionButton btn btn-rounded-button z-depth-1
                waves-effect waves-light text-capitalize" style="padding:
                .3rem 1.6rem;font-size: .85rem;width:100%;" id="101">{{butttonname}}</button>
              <button i18n="@@TMRunButton" type="button" (click)="cancel()"
                [style.border-color]="buttonColor"
                class="cancelButton btn btn-rounded-button z-depth-1
                waves-effect waves-light text-capitalize" style="padding:
                .3rem 1.6rem;font-size: .85rem;width:100%;">Cancel</button>
            </div>
             <div *ngIf="isViewAction" style="display: flex;justify-content: center; width: 20%; height:fit-content;margin:auto; margin-top: 1rem;" >
             
              <button i18n="@@TMRunButton" type="button" (click)="cancel()"
                [style.border-color]="buttonColor"
                class="cancelButton btn btn-rounded-button z-depth-1
                waves-effect waves-light text-capitalize" style="padding:
                .3rem 1.6rem;font-size: .85rem;width:100%;">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </div>








  
<div>
     <mat-expansion-panel [expanded]="false" style="border-radius: 0.8vh 0.8vh 0 0; box-shadow: none;margin-top: 50px;">
        <mat-expansion-panel-header style="max-height: 50px; background: rgb(228
          227 230 / 41%);border: 1px solid #a9a9a9a8;">
          <mat-panel-title>
            <label style="font-size: 22px; font-weight: 500; margin-top: 10px;"
              i18n="@@spmsUserReg" class="textColour">Verification Execution Status</label>
            <span class="example-spacer"></span>
          </mat-panel-title>
          <mat-panel-description>

          </mat-panel-description>
        </mat-expansion-panel-header>
        <div [style.background-color]="backgroundColorScreen" style="margin-left: -35px; margin-top: -50px;">
       <!-- <div> -->


          <mat-toolbar class="agGridtoperDiv card" style="background: rgb(244 243 245);border-top: 1px solid #a9a9a9a8;border-right: 1px solid #a9a9a9a8;border-left: 1px solid #a9a9a9a8;">

             
              <span class="example-spacer"></span>
              

                 
                  <button class="refreshrunButton popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="buttonColor" title="Refresh" (click) = "refreshh()">
                      Refresh<em style="padding: 0px 0px 0px 10px;" class="fas fa-refresh" title="Refresh"></em>
                  </button>
                  
                  <div class="insertPageNoDiv">
                      <mat-form-field appearance="outline">
                          <mat-label i18n="@@Targetpageno">Page No</mat-label>
                          <input matInput type="text" (input)="onRunSearchChange($event.target.value)">
                      </mat-form-field>
                  </div>
                  <div class="selectRecordsDiv" style="width:9.5%">
                      <mat-form-field appearance="outline" style="width:100%">
                          <mat-label i18n="@@Targetrecords" style="color:black">Records</mat-label>
                          <mat-select  [(ngModel)]="RunpageSize1"  (ngModelChange)="onRunPageSizeChanged(value)">
                              <mat-option value="10" selected>10</mat-option>
                              <mat-option value="200">200</mat-option>
                              <mat-option value="300">300</mat-option>
                              <mat-option value="400">400</mat-option>
                          </mat-select>

                      </mat-form-field>
                  </div>
                  <div class="card pagination paginationFirstButton paginationFirstlastButton">
                      <em class="fas fa-angle-double-left waves-effect waves-light" (click)="onRunBtFirst1()"></em>
                  </div>
                  <div class="card pagination paginationButtons btn-rounded">
                      <ul>
                          <li class="paginationliicon">
                              <em class="fas fa-angle-left waves-effect waves-light" (click)="onRunBtPrevious1()"></em>
                          </li>
                          <li>{{RuncurrentPage1}}/{{RuntotalPages1}}</li>
                          <li class="paginationliicon" style="padding:0;">
                              <em class="fas fa-angle-right waves-effect waves-light" (click)="onRunBtNext1()"></em>
                          </li>
                      </ul>
                  </div>
                  <div class="card pagination paginationLastButton paginationFirstlastButton">
                      <em class="fas fa-angle-double-right waves-effect waves-light" (click)="onRunBtLast1()"></em>
                  </div>

          </mat-toolbar>
      

          <div>

              
            
            <div >
              <ag-grid-angular class="ag-theme-balham table-width-tabs tablestyles square scroolbar-dusty-grass square thin" 
              style="height: 200px;"
              [columnDefs]="columnDefsExtractTemp" 
              [animateRows]="true"  
              [pagination]="true" 
              [defaultColDef]="defaultColDef" 
              [suppressPaginationPanel]="true" [rowHeight]="35" [headerHeight]="35" 
              [enableBrowserTooltips]="true" 
              [floatingFiltersHeight]="45"[paginationPageSize]="paginationPageSize" 
              [paginationNumberFormatter]="paginationNumberFormatter" 
              [enableRangeSelection]="true" [debug]="true" 
              [rowClassRules]="rowClassRules" 
              (paginationChanged)="onloadPaginationChanged1()" 
              [components]="components"  
              (gridReady)="retrieveInstructionsBasedOnActivity($event)" 
              [hidden]="!true">

              </ag-grid-angular> 
            </div>

          </div>

      </div>





</mat-expansion-panel>

    </div>













    <div>
      <mat-toolbar class="agGridtoperDiv card" style="
        background: rgb(228 227 230 / 41%);border-top: 1px solid #a9a9a9a8;
        border-right: 1px solid #a9a9a9a8;
        border-left: 1px solid #a9a9a9a8;">
        <label i18n="@@spmsUserReg" class="textColour">Stage Object</label>
        <span class="example-spacer"></span>
        <!-- <button class="refreshrunButton popup gridColour btn btn-rounded-button
          z-depth-1 waves-effect waves-light text-capitalize"
          [style.background-color]="buttonColor" title="Refresh"
          (click)="refreshRun()">
          Refresh<em style="padding: 0px 0px 0px 10px;" class="fas fa-refresh"
            title="Refresh"></em>
        </button> -->
       <!-- Export Button -->
<!-- <button class="refreshrunButton popup gridColour btn btn-rounded-button
z-depth-1 waves-effect waves-light text-capitalize"
[style.background-color]="buttonColor" title="Import Data"
(click)="importData()" id="102">
Import
<em class="fas fa-download" style="padding-left: 10px;" title="Import Data"></em>
</button> -->

<!-- Import Button -->
<!-- <button class="refreshrunButton popup gridColour btn btn-rounded-button
z-depth-1 waves-effect waves-light text-capitalize"
[style.background-color]="buttonColor" title="Export Data"
(click)="exportData()" id="103">
Export
<em class="fas fa-upload" style="padding-left: 10px;" title="Export Data" ></em>
</button> -->
        <div [hidden]="isvisible">
        <!-- <button class="refreshrunButton popup gridColour btn btn-rounded-button
        z-depth-1 waves-effect waves-light text-capitalize"
        [style.background-color]="buttonColor" title={{ButtonApprove}} id="103" [disabled]="isdisable" (click)="ApproveAttribute()">
        {{ButtonApprove}}</button> -->
          <app-common-button  [label]="ButtonApprove" [title]="ButtonApprove" [disabled]="isdisable"
          [buttonId]="103" [critical]="true" width="100px"(clicked)="ApproveAttribute()" style="margin-left: 8px">
        </app-common-button>
        <button class="refreshrunButton popup gridColour btn btn-rounded-button
        z-depth-1 waves-effect waves-light text-capitalize"
        [style.background-color]="buttonColor" title="View Result" id="104" [disabled]="isdisable" (click)="Viewresults()">
        View Result</button>

        <button class="refreshrunButton popup gridColour btn btn-rounded-button
        z-depth-1 waves-effect waves-light text-capitalize"
        [style.background-color]="buttonColor" title="Verify Mapping" id="105" [disabled]="isdisable" (click)="Mappingverify()">
        Verify Stage</button>
        </div>

        	   <!-- <button class="popup gridColour btn btn-rounded-button z-depth-1
          waves-effect waves-light text-capitalize"
          [style.background-color]="buttonColor" title="Upload File" id="108"
          (click)="excelFileUploadForObjects()">Upload File
          <em style="padding: 0px 0px 0px 10px;" class="fas fa-upload" title="Upload File"></em>
        </button> -->
        <app-common-button  label="Upload File" title="Upload File"
             [buttonId]="108" [critical]="true" width="100px"(clicked)="excelFileUploadForObjects()">
          </app-common-button>
        <button class="popup gridColour btn btn-rounded-button z-depth-1
          waves-effect waves-light text-capitalize"
          [style.background-color]="buttonColor" title="Download"
          (click)="onBtExport()">Download
          <em style="padding: 0px 0px 0px 10px;" class="fas fa-download
            example-icon" title="Download"></em>
        </button>
        <div class="insertPageNoDiv">
          <mat-form-field appearance="outline">
            <mat-label i18n="@@spmsUserRegpageno">Page No</mat-label>
            <input matInput type="text"
              (input)="onSearchChange($event.target.value)">
          </mat-form-field>
        </div>

        <div class="selectRecordsDiv" style="width:9.5%">
          <mat-form-field appearance="outline" style="width:100%">
            <mat-label i18n="@@spmsUserRegrecords" style="color:black">Records</mat-label>
            <mat-select [(ngModel)]="pagesize"
              (ngModelChange)="onPageSizeChanged(value)">
              <mat-option value="10" selected>10</mat-option>
              <mat-option value="200">200</mat-option>
              <mat-option value="300">300</mat-option>
              <mat-option value="400">400</mat-option>
            </mat-select>

          </mat-form-field>
        </div>
        <div class="card pagination paginationFirstButton
          paginationFirstlastButton">
          <em class="fas fa-angle-double-left waves-effect waves-light"
            (click)="onBtFirst()"></em>
        </div>
        <div class="card pagination paginationButtons btn-rounded">
          <ul>
            <li class="paginationliicon"><em class="fas fa-angle-left
                waves-effect waves-light"
                (click)="onBtPrevious()"></em></li>
            <li>{{currentpage}}/{{totalpages}}</li>
            <li class="paginationliicon" style="padding:0;"><em
                class="fas fa-angle-right waves-effect waves-light"
                (click)="onBtNext()"></em></li>
          </ul>
        </div>
        <div class="card pagination paginationLastButton
          paginationFirstlastButton">
          <em class="fas fa-angle-double-right waves-effect waves-light"
            (click)="onBtLast()"></em>
        </div>
      </mat-toolbar>
    </div>
    <ag-grid-angular class="ag-theme-balham table-width tablestyles square
      scroolbar-dusty-grass square thin"
      [columnDefs]="columnDefs" [animateRows]="true"
      [pagination]="true" [defaultColDef]="defaultColDef"
      [suppressPaginationPanel]="true" [rowHeight]="35"
      [headerHeight]="35" [enableBrowserTooltips]="true"
      [floatingFiltersHeight]="45"
      [paginationPageSize]="paginationPageSize"
      [paginationNumberFormatter]="paginationNumberFormatter"
      [enableRangeSelection]="true" [debug]="true"
      [rowClassRules]="rowClassRules"
      [getRowStyle]="getRowStyle"
      (paginationChanged)="onPaginationChanged()"
      [components]="components"
      (gridReady)="onGridReady($event)" [hidden]="!true">
    </ag-grid-angular>
  </div> 
</div>

